import { render, staticRenderFns } from "./editChainSupplierCatalog.vue?vue&type=template&id=04515cdb&scoped=true"
import script from "./editChainSupplierCatalog.vue?vue&type=script&lang=js"
export * from "./editChainSupplierCatalog.vue?vue&type=script&lang=js"
import style0 from "./editChainSupplierCatalog.vue?vue&type=style&index=0&id=04515cdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04515cdb",
  null
  
)

export default component.exports